// FamilyDetails.js
import React from "react";
import "../Styles/family.css";

const FamilyDetails = ({ familyMembers, relationList, familyWealth }) => {
  // console.log("familyMembers", familyMembers);

  const propertyTypeOptions = [
    { id: 1, name: "Land" },
    { id: 2, name: "House" },
    { id: 3, name: "Business" },
    { id: 4, name: "Vehicle" },
    { id: 5, name: "Jewellery" },
    { id: 6, name: "Investment" },
    { id: 7, name: "Other" },
  ];

  // Ownership Type options
  const ownershipTypeOptions = [
    { id: 1, name: "Individual" },
    { id: 2, name: "Joint" },
    { id: 3, name: "Ancestral" },
    { id: 4, name: "Inherited" },
  ];

  const getPropertyType = (id) => {
    let val = propertyTypeOptions.find((option) => option.id === id);

    return val?.name; // optional chaining to avoid error if not found
  };

  const getOwnershipType = (id) => {
    let val = ownershipTypeOptions.find((option) => option.id === id);

    return val?.name;
  };

  return (
    <div className=" mt-4 p-3">
      <h6 className="fam-title mb-3">Family</h6>
      <div className="row g-3">
        {familyMembers.map((member, index) => (
          <div className="col-md-6" key={index}>
            <div
              style={{ backgroundColor: "#F9F6F8", borderRadius: 22 }}
              className="   p-3 shadow-sm h-100"
            >
              <div className="d-flex justify-content-between align-items-start ">
                <div className="family-member-name">
                  {member.FamilyMemberName}
                </div>
                <span className="family-rel">
                  {" "}
                  {
                    relationList.find(
                      (rel) => rel.RelationshipId === member.RelationshipId
                    )?.RelationshipName
                  }
                </span>
              </div>
              <div className="text-muted mb-2 small">{member.Occupation}</div>
              <p className="mb-0 small">{member.RoleDesc}</p>
            </div>
          </div>
        ))}
      </div>
      {familyWealth?.length > 0 && <h6 className="fam-title mb-3 mt-4">Family wealth</h6>}
      <div className="row g-3">
        {familyWealth?.map((member, index) => (
          <div className="col-md-6" key={index}>
            <div
              style={{ backgroundColor: "#F9F6F8", borderRadius: 22 }}
              className="   p-3 shadow-sm h-100"
            >
              <div className="d-flex justify-content-between align-items-start ">
                <div className="family-member-name">
                  {" "}
                  Property : {getPropertyType(member?.PropertyType)}{" "}
                </div>
                <span className="family-rel">
                  {" "}
                  {getOwnershipType(member?.OwnershipType)}
                </span>
              </div>
              <div className="text-muted mb-2 small pt-2">
                EstimatedValue : {member.EstimatedValue}
              </div>
              <div className="text-muted mb-2 small">
                Property Description : {member.Description} {", "}{" "}
                {member.Notes}
              </div>

              <p className="mb-0 small">Location : {member.Location}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FamilyDetails;
